import { makeStyles, Theme } from "@material-ui/core";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

export const useStyles = makeStyles((theme: Theme) => {
  const { applyStepSuccess, gray30, gray40 } = useNormalizedBrandPaletteValues(
    theme
  );

  return {
    additionalParagraph: {
      marginTop: "1rem",
    },
    ukAgreement: {
      fontSize: "0.9rem",
    },
    copyButton: { width: "5rem", height: "3rem", marginLeft: "0px" },
    dark: {
      background: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    divider: {
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    stepBulletList: {
      paddingLeft: "1rem",
    },
    light: {
      background: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    link: {
      color: theme.palette.info.main,
    },
    listItem: {
      listStyle: "none",
      paddingBottom: 0,
      paddingLeft: theme.spacing(1),
      "&:before": {
        content: '"\\2022"',
        display: "inline-block",
        fontSize: "20px",
        marginLeft: theme.spacing(-1),
        verticalAlign: "text-bottom",
        width: theme.spacing(3),
      },
    },
    shortButton: {
      height: 48,
    },
    statusActionButton: {
      width: "8rem",
    },
    statusLabel: {
      fontSize: theme.typography.fontSize,
    },
    statusSuccess: {
      color: applyStepSuccess,
    },
    statusWarn: {
      color: theme.palette.warning.main,
    },
    statusError: {
      color: theme.palette.error.main,
    },
    statusWrapper: {
      border: `1px solid ${theme.palette.grey.A400}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
    },
    heading: {
      fontWeight: theme.typography.fontWeightBold,
    },
    subtitle: {
      fontSize: "0.9rem",
    },
    trainingLink: {
      color: theme.palette.common.black,
    },
    cardTapCounter: {
      color: gray30,
    },
    blackUnderlineLink: {
      color: theme.palette.common.black,
      textDecoration: "underline",
    },
    grayUnderlineLink: {
      color: gray40,
      textDecoration: "underline",
    },
    addCashPayStepValuePropFactBody: {
      marginBottom: theme.spacing(2),
      color: gray40,
    },
    addCashPayStepValuePropFactHeader: {
      fontSize: `${18 / 16}rem`,
      fontWeight: theme.typography.fontWeightBold,
    },
    addCashPayStepValuePropFactWrapper: {
      display: "flex",
    },
    addCashPayStepValuePropFactsWrapper: {
      height: "100%",
      [theme.breakpoints.down("sm")]: {
        alignItems: "flex-start",
      },
    },
    addCashPayStepValuePropFooterItem: {
      fontSize: `${10 / 16}rem`,
      color: gray40,
      marginBottom: theme.spacing(2),
    },
    cashPayLogoSubtext: {
      fontSize: `${14 / 16}rem`,
      color: gray30,
    },
    skipStepLink: {
      cursor: "pointer",
      color: theme.palette.common.black,
    },
    addCashPayButton: {
      minWidth: 188,
      height: 48,
    },
    cashpayIntegrationInstructions: {
      color: gray40,
    },
    cursorPointer: {
      cursor: "pointer",
    },
  };
});
